export default __webpack_public_path__ + "static/media/og_home_1200x628.c5137545.png";